import React, { useState, useEffect } from 'react';
import { useUser } from '../../context/UserContext';
import { fetchWithAuth } from '../../utils/fetchWithAuth';
import GroupedSelect from '../UI/GroupedSelect';
import actionLabels from '../../config/actionLabels';

const AssignManagerSelect = ({ phase, onAssign }) => {
    const { logout } = useUser();
    const [managers, setManagers] = useState({});
    const [currentManager, setCurrentManager] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchManagers = async () => {
            try {
				
                const res = await fetchWithAuth(
                    `${process.env.REACT_APP_API_URL}/orders/${phase.departmentId}/users`,
                    {},
                    logout
                );
                const data = await res.json();
                // Преобразуем данные в формат для GroupedSelect
                const formattedData = Object.entries(data).reduce((acc, [position, users]) => {
                    acc[position] = users.map(user => ({
                        value: user._id,
                        label: `${user.lastName} ${user.fullName} ${user.firstName} (${user.shiftSchedule})`
                    }));
					
                    return acc;
                }, {});
                setManagers(formattedData);

                if (phase.phaseManager) {
                    const managerRes = await fetchWithAuth(
                        `${process.env.REACT_APP_API_URL}/orders/manager/${phase.phaseManager}`,
                        {},
                        logout
                    );
                    const managerData = await managerRes.json();
                    setCurrentManager(managerData);
                }
            } catch (err) {
                console.error('Ошибка загрузки менеджеров:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchManagers();
    }, [phase.departmentId, phase.phaseManager, logout]);

    if (loading) return <div>Загрузка...</div>;

    return (
        <GroupedSelect
            value={phase.phaseManager || ''}
            onChange={onAssign}
            options={managers}
            placeholder={"Выберите руководителя"}
        />
    );
};

export default AssignManagerSelect;
